import React, { useContext } from "react";
import "./Daily.css";
import { Context } from "../../../context/Context";
import { formatter, formatter2 } from "../../../utils/helpers";
import { translations } from "../../../utils/lang";
import { DailyExpand } from "./dailyExpand/DailyExpand";
import { ArrowDown, ArrowUp } from "../../ui";
import { rowToggleProps } from "../reportUtils";
import usePagedReport from "../usePagedReport";
import { PagedDeleteDialog, PagedPanel, PagedRows, PagedStates } from "../PagedReportParts";

const KIND = "daily";
const DETAIL_GROUP_BY = ["month", "date", "app"];
const n = (value) => Number(value) || 0;

// Daily table with server-side filtering, sorting and paging (PAGED_REPORTS). Same cards, actions and permissions as Daily.jsx; the browser holds
// one page of one store at a time and prints the server's totals for every header.
export const DailyPaged = ({ active = true }) => {
  const { lang } = useContext(Context);
  const report = usePagedReport({ kind: KIND, detailGroupBy: DETAIL_GROUP_BY, amountField: "completedAmount", active });
  const { text, stores, openStore } = report;
  const titles = translations[lang].reports.daily;

  const fields = [
    { key: "app", filterKey: "apps", onChange: (selected) => report.update({ apps: selected }) },
    { key: "store", filterKey: "stores", onChange: report.changeStores },
    { key: "branch", filterKey: "branches", onChange: (selected) => report.update({ branches: selected }) },
  ];

  return (
    <div className="report-daily-table">
      <PagedPanel report={report} prefix="daily" titles={titles.inputTitles} fields={fields} />

      <div className="report-daily-card-col">
        <div className="report-daily-header-card">
          {titles.header.map((item, i) => (
            <p key={i}>
              <strong>{item}</strong>
            </p>
          ))}
        </div>
        <PagedStates report={report} />
        {stores.map((store) => {
          const id = String(store.storeId);
          const isExpanded = openStore === id;
          return (
            <React.Fragment key={id}>
              <div
                {...rowToggleProps(isExpanded, () => report.toggleStore(id))}
                className={`report-daily-summary-card ${isExpanded ? "colored" : ""} ${store.pending > 0 ? "notApproved" : ""}`}
              >
                <div className="report-daily-p center">
                  <p>
                    <strong>{store.store}</strong>
                  </p>
                  {store.pending > 0 && <span className="report-pending-tag">{text.pendingApproval}</span>}
                </div>
                <div className="report-daily-p">
                  <p>
                    <strong>{formatter2.format(n(store.completed))}</strong> / <strong>{formatter.format(n(store.completedAmount).toFixed(2))}</strong>
                  </p>
                </div>
                <div className="report-daily-p">
                  <p>
                    <strong>{formatter2.format(n(store.rejected))}</strong> / <strong>{formatter.format(n(store.rejectedAmount))}</strong>
                  </p>
                </div>
                <div className="report-daily-p">
                  <p>
                    <strong>{formatter2.format(n(store.canceled))}</strong> / <strong>{formatter.format(n(store.canceledAmount))}</strong>
                  </p>
                </div>
                <div className="report-daily-p">
                  <p>
                    <strong>{formatter2.format(n(store.endurance))}</strong> / <strong>{formatter.format(n(store.enduranceAmount))}</strong>
                  </p>
                </div>
                <div className="report-daily-p">
                  <p>
                    <strong>{formatter2.format(n(store.refund))}</strong> / <strong>{formatter.format(n(store.refundAmount))}</strong>
                  </p>
                </div>
                <div className="report-expand-icon">{isExpanded ? <ArrowUp size={18} /> : <ArrowDown size={18} />}</div>
              </div>
              {isExpanded && (
                <PagedRows report={report}>
                  {(anchors, groupRows, hierarchy) => <DailyExpand data={anchors} groups={groupRows} paged={hierarchy} onRefresh={report.refresh} />}
                </PagedRows>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <PagedDeleteDialog report={report} kind={KIND} />
    </div>
  );
};
